import { findTimeZone, getZonedTime } from 'timezone-support'

export const getTimeZone = (iso, tzId) => {
  const tz = findTimeZone(tzId)
  const date = new Date(iso)
  const z = getZonedTime(date, tz)
  if (!z.zone) {
    return ''
  }
  // z.abbreviation is the DST-aware abbr
  const abbr = z.zone.abbreviation // “CET” / “CEST” / “CST”
  const hrs = z.zone.offset / 60 // offset in minutes → hours
  const gmt = `GMT${hrs >= 0 ? '+' : ''}${hrs}`
  return `${abbr} (${gmt})`
}
